// src/FirmaCertificado.js — JCUMAS 060.013
// Firma (AutoFirma) del borrador de un certificado ya generado por el admin.
// Deliberadamente independiente de FirmaElectronica.js / PUT /solicitudes/<id>
// para no arriesgar el flujo de firma ya existente: usa sus propios
// endpoints dedicados (POST .../generar-certificado, PUT .../certificado-firmado).
import { Button, Modal, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_API_URL;

function FirmaCertificado({ documentoId, solicitudId, onFirmado }) {
  const [algorithm] = useState("SHA256withRSA");
  const [format] = useState("PAdES");
  const [showModal, setShowModal] = useState(false);
  const [signedData, setSignedData] = useState("");
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (window.AutoScript) {
      window.AutoScript.cargarAppAfirma();
    } else {
      console.error("AutoScript no se ha cargado correctamente.");
    }
  }, []);

  const obtenerBorradorBase64 = async () => {
    setCargando(true);
    try {
      const res = await fetch(`${BASE_URL}/documentos/${documentoId}/download`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.error("Error al descargar el borrador del certificado:", e);
      alert("No se pudo descargar el borrador del certificado.");
      return null;
    } finally {
      setCargando(false);
    }
  };

  const iniciarFirma = async () => {
    const base64 = await obtenerBorradorBase64();
    if (!base64) return;

    const extraParams = [
      "signaturePage=1",
      "signaturePositionOnPageLowerLeftX=100",
      "signaturePositionOnPageLowerLeftY=100",
      "signaturePositionOnPageUpperRightX=400",
      "signaturePositionOnPageUpperRightY=200",
      "layer2Text=Firmado por $$SUBJECTCN$$ el día $$SIGNDATE=dd/MM/yyyy$$ con certificado emitido por $$ISSUERCN$$",
      "layer2FontFamily=Arial",
      "layer2FontSize=12",
      "layer2FontColor=000000",
      "layer2FontStyle=0",
    ].join("\n");

    try {
      window.AutoScript.sign(
        base64,
        algorithm,
        format,
        extraParams,
        (firmado) => {
          setSignedData(firmado);
          setShowModal(true);
        },
        (type, message) => {
          console.error("Error al firmar:", message);
          alert("Error al firmar: " + message);
        }
      );
    } catch (e) {
      console.error("Error al invocar AutoScript para firmar:", e);
    }
  };

  const confirmarEntrega = async () => {
    setGuardando(true);
    try {
      const res = await fetch(`${BASE_URL}/solicitudes/${solicitudId}/certificado-firmado`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ Documento: signedData }),
      });
      if (res.ok) {
        setShowModal(false);
        if (onFirmado) onFirmado();
      } else {
        const err = await res.json().catch(() => ({}));
        alert(err.error || "Error al entregar el certificado firmado.");
      }
    } catch (e) {
      alert("No se pudo conectar con el servidor.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <Button size="sm" variant="primary" onClick={iniciarFirma} disabled={cargando}>
        {cargando ? (
          <><Spinner animation="border" size="sm" className="me-1" />Cargando…</>
        ) : (
          <><i className="bi bi-vector-pen me-1"></i>Firmar y enviar</>
        )}
      </Button>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Certificado firmado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          El certificado se ha firmado correctamente. Al confirmar, se enviará
          al usuario como "enviado" junto con una notificación.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={confirmarEntrega} disabled={guardando}>
            {guardando ? <Spinner animation="border" size="sm" /> : "Confirmar y entregar"}
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FirmaCertificado;
